import React, { useEffect } from 'react';
import RegionHeader from './RegionHeader';

export default function StreamflowGraphTable(props) {
  const buttontext = "Graph View";
	const buttonValue = ("sfpctgrf");
  const [ sfdata, setSfdata ] = React.useState([]);

  const dataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/sf_pctl_daily.json";

  useEffect(() => {
    fetch(dataFileName) 
      .then(res => res.json())
      .then(json => {
        setSfdata(json);
      })
      .catch(err => console.error("Fetch error retrieving sf_pctl_daily data:", err));
  }, [dataFileName]);

  return (
    <>
      <RegionHeader
				title={"Streamflow"}
				buttontext={buttontext}
				buttonValue={buttonValue}
				handleButtonClick={props.handleButtonClick}
      />
      {sfdata.length > 0 &&
        <table className="pcpnTable-container">
          <caption>
            Percent of Streamflow Gages at Index Severity Level
          </caption>
          <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Level 0: <br />&gt;30 percentile</th>
              <th scope="col">Level 1: <br />20-30 percentile</th>
              <th scope="col">Level 2: <br />10-20 percentile</th>
              <th scope="col">Level 3: <br />2-10 percentile</th>
              <th scope="col">Level 4: <br />&le;2 percentile</th>
              <th scope="col">Number of gages</th>
            </tr>
          </thead>
          <tbody>
            {sfdata.toReversed().map((rd, i) => (
                <tr key={i}>
                  <th scope="row">{rd.date}</th>
                  <td>{rd.level0.toFixed(1)}%</td>
                  <td>{rd.level1.toFixed(1)}%</td>
                  <td>{rd.level2.toFixed(1)}%</td>
                  <td>{rd.level3.toFixed(1)}%</td>
                  <td>{rd.level4.toFixed(1)}%</td>
                  <td>{rd.count}</td>
                </tr>
            ))}
          </tbody>
        </table>
  }
    </>
  );
}
